module.exports = __webpack_public_path__ + "static/media/dashboard-graph.1d4e11f5.svg";